import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import BookmarkButton from './components/bookmark-button/BookmarkButton';
import { IBookmarkButtonProps } from './components/types';

function hydrateBookmark() {
    if (window.__PRELOADED_BOOKMARK_STATE__) {
        window.__PRELOADED_BOOKMARK_STATE__.forEach((hydratedProps: IBookmarkButtonProps) => {
            const anchorElement = hydratedProps.containerId ? document.getElementById(hydratedProps.containerId) : null;
            if (anchorElement) {
                hydrateRoot(anchorElement, <BookmarkButton {...hydratedProps} />);
            }
        });
        delete window.__PRELOADED_BOOKMARK_STATE__;
    }
}

hydrateBookmark();
